/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ReplaceHomeHealthPractitionerAssignmentRole
 */
export interface ReplaceHomeHealthPractitionerAssignmentRole {
    /**
     *
     * @type {string}
     * @memberof ReplaceHomeHealthPractitionerAssignmentRole
     */
    role: ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum | null;
    /**
     *
     * @type {boolean}
     * @memberof ReplaceHomeHealthPractitionerAssignmentRole
     */
    selected: boolean;
    /**
     *
     * @type {string}
     * @memberof ReplaceHomeHealthPractitionerAssignmentRole
     */
    expected_assignment?: ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum;
    /**
     *
     * @type {Date}
     * @memberof ReplaceHomeHealthPractitionerAssignmentRole
     */
    expected_updated_at?: Date;
    /**
     *
     * @type {boolean}
     * @memberof ReplaceHomeHealthPractitionerAssignmentRole
     */
    reassign?: boolean;
}


/**
 * @export
 */
export const ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum = {
    InitialReferring: 'INITIAL_REFERRING',
    F2FEncounter: 'F2F_ENCOUNTER',
    F2FCertifying: 'F2F_CERTIFYING',
    PlanOfCareSigning: 'PLAN_OF_CARE_SIGNING'
} as const;
export type ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum = typeof ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum[keyof typeof ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum];

/**
 * @export
 */
export const ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum = {
    Absent: 'absent'
} as const;
export type ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum = typeof ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum[keyof typeof ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum];


/**
 * Check if a given object implements the ReplaceHomeHealthPractitionerAssignmentRole interface.
 */
export function instanceOfReplaceHomeHealthPractitionerAssignmentRole(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "selected" in value;

    return isInstance;
}

export function ReplaceHomeHealthPractitionerAssignmentRoleFromJSON(json: any): ReplaceHomeHealthPractitionerAssignmentRole {
    return ReplaceHomeHealthPractitionerAssignmentRoleFromJSONTyped(json, false);
}

export function ReplaceHomeHealthPractitionerAssignmentRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceHomeHealthPractitionerAssignmentRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'role': json['role'],
        'selected': json['selected'],
        'expected_assignment': !exists(json, 'expected_assignment') ? undefined : json['expected_assignment'],
        'expected_updated_at': !exists(json, 'expected_updated_at') ? undefined : (new Date(json['expected_updated_at'])),
        'reassign': !exists(json, 'reassign') ? undefined : json['reassign'],
    };
}

export function ReplaceHomeHealthPractitionerAssignmentRoleToJSON(value?: ReplaceHomeHealthPractitionerAssignmentRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'role': value.role,
        'selected': value.selected,
        'expected_assignment': value.expected_assignment,
        'expected_updated_at': value.expected_updated_at === undefined ? undefined : (value.expected_updated_at.toISOString()),
        'reassign': value.reassign,
    };
}
